/** Display helpers — a copy of the few the backoffice needs from apps/web/src/lib/fa.ts. */

const PERSIAN_DIGITS = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] as const

export const toPersianDigits = (input: string | number): string =>
  String(input).replace(/[0-9]/g, (d) => PERSIAN_DIGITS[Number(d)] as string)

export const toLatinDigits = (input: string): string =>
  input
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06f0))
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660))

const groupDigits = (n: number): string =>
  Math.trunc(Math.abs(n))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '٬')

/** Money reaches the UI as Rial and is always shown as Toman, never as a bare number. */
export const formatToman = (rial: number): string =>
  `${toPersianDigits(groupDigits(Math.round(rial / 10)))} تومان`

/** `۰۹۱۲ ۳۴۵ ۶۷۸۹` from the API's canonical `9123456789`. */
export const formatMobile = (canonical: string): string => {
  const m = `0${canonical}`
  return toPersianDigits(`${m.slice(0, 4)} ${m.slice(4, 7)} ${m.slice(7)}`)
}

/** Tehran time, Jalali calendar — the same rule as the customer app. */
const jalaliDate = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'Asia/Tehran',
})

const jalaliDateTime = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'Asia/Tehran',
})

/** `۱ آبان ۱۴۰۵، ۱۲:۳۰` */
export const formatJalaliDateTime = (value: string): string => jalaliDateTime.format(new Date(value))

/** `۱ آبان ۱۴۰۵` — also right for date-only strings (`1992-01-01`), which parse to UTC midnight. */
export const formatJalaliDate = (value: string): string => jalaliDate.format(new Date(value))
